module.exports = __webpack_public_path__ + "static/media/Ellipse.c3acf84e.svg";